import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { getConsentState, grantConsent, denyConsent } from '@/lib/consent';
import { useTranslation } from '@/hooks/useTranslation';

export function CookieConsentBanner() {
  const { translate: t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getConsentState() === 'pending');
  }, []);

  if (!visible) return null;

  const handleGrant = () => {
    grantConsent();
    setVisible(false);
  };

  const handleDeny = () => {
    denyConsent();
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4">
      <div className="mx-auto max-w-xl rounded-lg border bg-background p-4 shadow-lg flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground">
          {t('cookie_consent_message') || 'We use analytics cookies to understand how AlphaSignal is used and improve the platform. You can accept or decline non-essential cookies.'}
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={handleDeny}>
            {t('cookie_consent_decline') || 'Decline'}
          </Button>
          <Button size="sm" onClick={handleGrant}>
            {t('cookie_consent_accept') || 'Accept'}
          </Button>
        </div>
      </div>
    </div>
  );
}
